import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { apiErrorMessage, useLogin } from '../lib/api'
import { useAuth } from '../lib/auth'
import { AuthShell, ArrowRightIcon } from '../components/AuthShell'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const login = useLogin()
  const auth = useAuth()
  const nav = useNavigate()

  const submit = (e: FormEvent) => {
    e.preventDefault()
    login.mutate(
      { email, password },
      {
        onSuccess: async () => {
          await auth.refresh()
          nav('/', { replace: true })
        },
      },
    )
  }

  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-card__header">
          <h1 className="auth-card__title">Welcome back</h1>
          <p className="auth-card__subtitle">Sign in to continue your challenge.</p>
        </div>

        <form className="auth-card__body" onSubmit={submit}>
          <div className="field">
            <label className="field__label" htmlFor="login-email">Email address</label>
            <input
              id="login-email"
              className="field__input"
              type="email"
              required
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <div className="auth-card__label-row">
              <label className="field__label" htmlFor="login-pw">Password</label>
              <Link to="/forgot-password" className="auth-card__inline-link">Forgot password?</Link>
            </div>
            <input
              id="login-pw"
              className="field__input"
              type="password"
              required
              autoComplete="current-password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {login.isError && (
            <div className="auth-card__error" role="alert" style={{ display: 'flex' }}>
              {apiErrorMessage(login.error)}
            </div>
          )}

          <button type="submit" className="btn btn--primary auth-card__submit" disabled={login.isPending}>
            {login.isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="auth-card__footer">
          New to Rival?
          <Link to="/register" className="auth-card__footer-link">
            Create account
            <ArrowRightIcon />
          </Link>
        </div>
      </div>
    </AuthShell>
  )
}
